// extracted by mini-css-extract-plugin
export default {"recos":"U7-z","productCardOverride":"V7-z","rowHasBadge":"W7-z"};